import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChildren,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';

import { AppModalService } from 'shared/modal/modal.service';
import { TableComponent } from 'shared/table/table/table.component';
import { RESET_PASSWORD_MODAL_NAME } from 'shared/modal/modal-names';
import { createFormControl } from 'utils/form-control';
import LanguageCodeMapper from 'utils/language-code-mapper';

@Component({
  moduleId: module.id,
  selector: 'profile-form',
  templateUrl: 'profile-form.component.html',
  styleUrls: ['profile-form.component.scss'],
})

export class ProfileFormComponent extends TableComponent implements OnChanges {
  form: UntypedFormGroup;

  @Input() segmentData: Array<any> = [];

  @Input() declare data: any;

  @ViewChildren('textInput') inputs: any;

  // public:
  constructor(
    protected appModalService: AppModalService,
    private fb: UntypedFormBuilder
  ) {
    super();
  }

  // hooks
  ngOnChanges(changes: any) {
    if (this.form) {
      this.updateForm();
      this.focusFirstInput();
    } else {
      this.createForm();
    }
  }

  // public
  createForm() {
    const formControls = this.createFormItem(this.data);
    this.form = this.fb.group(formControls);
  }

  // handlers
  onChangePasswordClick() {
    this.appModalService.showModal(RESET_PASSWORD_MODAL_NAME);
  }

  // private
  private createFormItem(obj: any = {}): any {
    return _.reduce(this.segmentData, (result: any, item: any) => {
      const control = new UntypedFormControl(obj[item.item_name], this.getItemValidators(item.validation));
      result[item.field_map] = control;
      return result;
    }, {});
  }

  private updateForm(): void {
    _.each(this.segmentData, (item: any) => {
      const control = this.form.get(item.field_map);
      if (control) { control.setValue(this.data[item.item_name]); }
    });
  }

  private focusFirstInput() {
    if (this.inputs && this.inputs.first) {
      _.defer(() => this.inputs.first.nativeElement.focus());
    }
  }
}
